import { useState } from "react";
import { FormInput } from "../Components/FormInputs/FormInputs";
import { FormSelect } from "../Components/FormSelect";
import ModalPopup from "../Components/ModalPopup/ModalPopup";
import { Button, message, Popover, Tooltip } from "antd";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

import { FaFilter } from "react-icons/fa6";

import { API } from "../Axios/Axios";

export default function FormControls() {
  const [modalVisible, setModalVisible] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [address, setAddress] = useState("");
  const [richValue, setRichValue] = useState("");
  const [toggle, setToggle] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  /// <summary>
  /// Added for validation Entity level testing.
  /// </summary>
  const handleSubmit = async () => {
    const obj = {
      Id: 0,
      FirstName: firstName,
      Address: address,
      IsActive: false,
    };

    try {
      const response = await API.post("/Medicine/Create", obj);
      console.log("Response:", response.data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const error = () =>
    messageApi.open({ type: "error", content: "This is an error message" });

  const warning = () =>
    messageApi.open({ type: "warning", content: "This is a warning message" });

  const popoverContent = (
    <div>
      <p>Content</p>
      <p>Content</p>
    </div>
  );

  return (
    <>
      {contextHolder}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="pageName">
              <h4>Form Controls</h4>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-lg-3 col-md-4 col-sm-6">
            <FormInput
              label="Input Text"
              placeholder="Enter"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              rules={[{ required: true, message: "Please enter!" }]}
            />
          </div>

          <div className="col-lg-12">
            <FormInput
              textArea
              label="TextArea"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Description..."
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="d-flex gap-2">
              <Button className="btn-submit" onClick={handleSubmit}>
                Submit
              </Button>
              <Button className="btn-cancel" onClick={error}>
                Cancel
              </Button>
              <Button className="btn-reset" onClick={warning}>
                Reset
              </Button>
              <Button
                className="btn-update"
                onClick={() => setModalVisible(true)}
              >
                Modal Popup
              </Button>
              <Popover content={popoverContent} title="Title" trigger="click">
                <Button className="btn-pdf">Popover Button</Button>
              </Popover>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-12">
            {toggle && (
              <div className="row" id="filterContent">
                {[...Array(4)].map((_, i) => (
                  <div
                    className="col-lg-3 col-md-4 col-sm-6"
                    key={crypto.randomUUID()}
                  >
                    <FormSelect
                      label="Select Knowledge"
                      options={[
                        { value: "jack", label: "Jack" },
                        { value: "lucy", label: "Lucy" },
                      ]}
                      rules={[{ required: true, message: "Please select!" }]}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="col-lg-3">
            <FormSelect
              label="Select Category"
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
              ]}
              rules={[{ required: true, message: "Please select!" }]}
            />
          </div>
          <div className="col-lg-3">
            <FormSelect
              label="Select Type"
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
              ]}
              rules={[{ required: true, message: "Please select!" }]}
            />
          </div>
          <div className="col-lg-3">
            <FormSelect
              label="Select Knowledge"
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
              ]}
              rules={[{ required: true, message: "Please select!" }]}
            />
          </div>
          <div className="col-lg-3">
            <div className="custom_group">
              <div className="d-none d-md-block">&nbsp;</div>
              <div className="d-flex gap-2 justify-content-end">
                <Tooltip title="Advanced Filter">
                  <Button
                    className="filterBtn"
                    shape="circle"
                    icon={<FaFilter />}
                    onClick={() => setToggle(!toggle)}
                  />
                </Tooltip>
                <Button className="btn-submit">Apply</Button>
                <Button className="btn-reset">Reset</Button>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mt-3">
            <ReactQuill
              theme="snow"
              value={richValue}
              onChange={setRichValue}
            />
          </div>
        </div>
      </div>

      <ModalPopup
        title="Modal Heading"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        okText="Submit"
        onOk={async () => {
          await handleSubmit();
          setModalVisible(false);
        }}
      >
        <p>Popup Content...</p>
        <p>Popup Content...</p>
        <p>Popup Content...</p>
      </ModalPopup>
    </>
  );
}
